import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1539.04532,215.441064 L1539.04532,1465.18083 L1838.25106,1165.97509 L1920,1247.83982 L1481.03368,1686.80614 L1042.18316,1247.83982 L1124.04788,1165.97509 L1423.25363,1465.18083 L1423.25363,215.441064 L1539.04532,215.441064 Z M438.966318,160 L877.932636,599.08211 L796.067907,680.831047 L496.862166,381.625305 L496.862166,1631.36508 L381.186262,1631.36508 L381.186262,381.625305 L81.9805205,680.831047 L0,599.08211 L438.966318,160 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSortLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSortLine, _Component);

  var _super = _createSuper(IconSortLine);

  function IconSortLine() {
    _classCallCheck(this, IconSortLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSortLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSort",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSortLine.displayName = "IconSortLine";
  return IconSortLine;
}(Component);

IconSortLine.glyphName = 'sort';
IconSortLine.variant = 'Line';
IconSortLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSortLine;
export { IconSortLine };